export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm text-foreground-400 max-w-[500px] mx-auto">
            有任何问题、建议或合作意向，欢迎随时与我们取得联系
          </p>
        </div>

        <div className="max-w-[700px] mx-auto">
          <div className="rounded-lg bg-background-200/60 border border-background-200/50 p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="flex flex-col items-center text-center gap-2">
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-mail-line text-lg"></i>
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-800">商务合作</h3>
                <p className="text-xs text-foreground-400">business@tiantangcinema.com</p>
              </div>

              <div className="flex flex-col items-center text-center gap-2">
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-customer-service-2-line text-lg"></i>
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-800">用户反馈</h3>
                <p className="text-xs text-foreground-400">feedback@tiantangcinema.com</p>
              </div>

              <div className="flex flex-col items-center text-center gap-2">
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                  <i className="ri-article-line text-lg"></i>
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-800">内容投稿</h3>
                <p className="text-xs text-foreground-400">submit@tiantangcinema.com</p>
              </div>
            </div>

            <div className="mt-6 pt-6 border-t border-background-200/30 text-center">
              <p className="text-xs text-foreground-400">
                我们会在收到邮件后 24 小时内回复，期待您的来信
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}